module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.numbers) ? _c('div', {
    staticClass: "special-highlights"
  }, [_c('div', {
    staticClass: "selected-balls-highlight"
  }, [_c('span', {
    staticClass: "heading float-left"
  }, [_vm._v(_vm._s(_vm._f("translate")('spot_hits')))]), _vm._v(" "), _c('span', {
    staticClass: "heading float-right"
  }, [_vm._v(_vm._s(_vm._f("translate")('spot_odds')))])]), _vm._v(" "), (_vm.bettingSvc.ticket.input.length) ? _c('div', _vm._l((_vm.numbers), function(row, key) {
    return _c('div', {
      key: key,
      staticClass: "paytable-row clearfix"
    }, [_c('span', {
      staticClass: "float-left"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('span', {
      staticClass: "float-right"
    }, [_vm._v(_vm._s(row.toFixed(2)))])])
  })) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25ab150a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PayTable.vue
// module id = 399
// module chunks = 0